var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsFolderOpenAngledFillBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#464646;}\n\t.st1{fill:#DB536A;}\n\t.st2{fill:#D04A02;}\n\t.st3{fill:#E0301E;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#2D2D2D;}\n\t.st6{fill:#7D7D7D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Guidelines_5_",
    d: "M19.9,22.5h22l6.5,10.6h24.2l6,6.6v10.6H35.4L16,69.7V27.8L19.9,22.5z M38.4,53.9H88L65.9,76.4 l-49.7,0.1L38.4,53.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsFolderOpenAngledFillBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_FolderOpenAngled_Fill_Black_RGB.52774e0688e9538f68eb739d05327b03.svg";
export { ForwardRef as ReactComponent };